/*! @azure/msal-browser v3.0.2 2023-08-18 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.0.2";

export { name, version };
